import React, { Component } from "react";
import Modal from "react-bootstrap/Modal";

export default class AddCategory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      form: {
        category: props.categoryToEdit?.displayName || "", // Pre-fill the form if editing
        image: null,
        imageURL: props.categoryToEdit?.image || "", // Pre-fill the image if editing
      },
      error: "",
    };
  }

  componentDidUpdate(prevProps) {
    // When the modal opens for editing, ensure form fields are updated
    if (
      prevProps.categoryToEdit !== this.props.categoryToEdit &&
      this.props.isEdit
    ) {
      this.setState({
        form: {
          category: this.props.categoryToEdit?.displayName || "",
          image: null,
          imageURL: this.props.categoryToEdit?.image || "",
        },
      });
    }
  }

  onSave = () => {
    const { form } = this.state;
    const { addSubCategory, showSubcategory, isEdit, categoryToEdit } =
      this.props;
    const { category, image } = form;
    const data = new FormData();

    if (addSubCategory) {
      data.append("parentId", showSubcategory);
    }
    data.append("displayName", category);
    if (image) {
      data.append("image", image);
    }
    data.append("isSizeExist", false);
    data.append("status", 1);
    data.append("seq_no", 0);
    data.append("is_popular", 0);

    if (isEdit) {
      // If editing, pass the category ID to edit it
      this.props.onEditCategory(data, categoryToEdit.id);
    } else {
      // Otherwise, add a new category
      this.props.onAddCategory(data);
    }
  };

  handleInputChange = (e) => {
    const { name, files, value } = e.target;
    const { form } = this.state;

    if (name === "file") {
      const file = files[0];
      this.setState({
        form: {
          ...form,
          image: file,
          imageURL: URL.createObjectURL(file),
        },
      });
    } else {
      this.setState({
        form: {
          ...form,
          [name]: value,
        },
      });
    }
  };

  render() {
    const { form, error } = this.state;
    const { show, onHide, isEdit } = this.props;

    return (
      <Modal show={show} onHide={onHide} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>{isEdit ? "Edit Category" : "Add Category"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="col-md-4">
              <div className="form-group">
                <label>Category</label>
                <input
                  type="text"
                  className="form-control"
                  name="category"
                  value={form.category}
                  onChange={this.handleInputChange}
                  placeholder="Enter category"
                />
              </div>
            </div>
            <div className="col-md-4 mt-4 pt-1">
              <label
                htmlFor="file-picker"
                className="btn btn-secondary"
                style={{ cursor: "pointer" }}
              >
                Choose Image
              </label>
              <input
                id="file-picker"
                name="file"
                type="file"
                onChange={this.handleInputChange}
                style={{ display: "none" }}
              />
            </div>
            <div className="col-md-4">
              {form.imageURL && (
                <img
                  src={form.imageURL}
                  alt="category"
                  width="100"
                  height="100"
                />
              )}
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-danger" onClick={onHide}>
            Close
          </button>
          <button
            className="btn btn-primary"
            onClick={this.onSave}
            disabled={!form.category || (isEdit && !form.imageURL)}
          >
            {isEdit ? "Save Changes" : "Save"}
          </button>
        </Modal.Footer>
      </Modal>
    );
  }
}
